import { useQuery } from '@tanstack/react-query';

import { type QueryOptions, apiClient } from './axios';

// Type definitions
export interface HealthResponse {
  status: 'healthy' | 'unhealthy';
  version?: string;
  timestamp: string;
  uptime?: number;
  environment?: string;
}

// API functions
export const fetchHealth = async (): Promise<HealthResponse> => {
  const response = await apiClient.get('/health');
  return response.data;
};

// React Query hooks
export const useHealth = (options?: QueryOptions) => {
  return useQuery({
    queryKey: ['health'],
    queryFn: fetchHealth,
    enabled: options?.enabled !== false,
    retry: options?.retry ?? false,
    refetchInterval: options?.refetchInterval ?? 60000, // Refetch every minute
    staleTime: 30000, // Data is fresh for 30 seconds
  });
};
